import { when } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CardStore } from '@intelingu/core/stores/CardStore';

interface AchievementProps {
}

@observer export class Achievement extends Component<AchievementProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;

    get color() {
        const name = this.cardStore.nextBuffer[0].achievement.name.toLowerCase();

        if (name.includes('gold')) {
            return 'gold';
        }

        if (name.includes('platin')) {
            return 'platin';
        }

        if (name.includes('silber')) {
            return 'silver';
        }

        if (name.includes('bronze')) {
            return 'bronze';
        }
    }

    render() {
        if (!this.cardStore.nextBuffer || !this.cardStore.nextBuffer.length || !this.cardStore.nextBuffer[0].achievement) {
            return null;
        }

        const achievement = this.cardStore.nextBuffer[0].achievement;

        return <>
            <div className={`achievement-banner ${this.color} animated`}>
                <div className="achievement-loader" />
                <div className="achievement-loader" />
                <div className="achievement-loader" />
                <div className="achievement-loader" />
                <div className="achievement-loader" />
                <div className="achievement-trophy acv-icon acv-logo" style={{
                    background: `url("${achievement.image}") no-repeat 65% 50%`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'none',
                    backgroundOrigin: 'content-box'
                }} />

                <div className="achievement-text">
                    {/*<div className="achievement-notification">Achievement Unlocked</div>*/}
                    <div className="achievement-name">{ achievement.name }</div>
                </div>
            </div>
        </>
    }

}
